<template>
  <div>
    <div class="d-flex" v-for="(openingHoursSlot, index) in models" v-bind:key="index">
      <div class="flex-1">
        <span class="day">
          {{
          i18n.database.table.opening_hours_slots.days[
          openingHoursSlot.day.toLowerCase()
          ].short
          }}
        </span>
      </div>
      <div>
        <div v-if="openingHoursSlot.slots.length > 0">
          <div
            v-for="(slot, index) in openingHoursSlot.slots"
            v-bind:key="index"
            class="d-inline-block"
          >
            <span class="time" v-if="slot.start_time">{{ slot.start_time }} - {{ slot.end_time }}</span>
            <span class="time" v-else>{{ i18n.app.opening_hours.closed }}</span>

            <span v-if="(index+1) < openingHoursSlot.slots.length" class="time">&&nbsp;</span>
          </div>
        </div>
        <div v-else>
          <span class="time">{{ i18n.app.opening_hours.closed }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "depot-opening-hours-item",
  props: ["models"]
};
</script>
